import axios from 'axios';
import store from '../store'
const endpoint = '/api/krainaabc/subprofile/unselect?device=www';

export function subprofileUnselect() {
    axios
        .get(endpoint)
        .then(() => { 
            store.dispatch("activeSubProfile");   
        })
        .catch((error) => {
            console.log(error);
        });       
}
